import type { ReactNode } from "react";
import { SiteFooter, SiteHeader } from "./components/SiteChrome.tsx";
import { CMSComponents } from "./engine/CMSComponent.tsx";
import type { PageModel, SiteSettings } from "./types.ts";

export interface CMSPageSlots {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
  belowFooter: ReactNode;
}

interface CMSPageProps {
  pageModel: PageModel;
  site: SiteSettings;
  year: number;
  render: (slots: CMSPageSlots) => ReactNode;
}

/** Maps site settings and the page model's regions onto slots for the layout. */
export default function CMSPage({ pageModel, site, year, render }: CMSPageProps) {
  const regions = pageModel.pageReference ?? { componentType: "Content" };

  const body = (
    <>
      <CMSComponents nodes={regions.top} />
      <CMSComponents nodes={regions.middle} />
      <CMSComponents nodes={regions.bottom} />
    </>
  );

  return (
    <>
      {render({
        header: <SiteHeader site={site} />,
        body,
        footer: <SiteFooter site={site} year={year} feedPath="/xss.xml" />,
        belowFooter: <CMSComponents nodes={regions.belowFooter} />,
      })}
    </>
  );
}
